import React from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaLinkedin } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">ThinkRise USA</h3>
            <p className="footer-description">
              Growth systems built for U.S. teams that need better data, stronger pipeline, and measurable revenue outcomes.
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/why-thinkrise-usa">Why ThinkRise USA</Link></li>
              <li><Link to="/solutions">Solutions</Link></li>
              <li><Link to="/products-industries">Products and Industries</Link></li>
              <li><Link to="/resources">Resources</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <div className="contact-info">
              <div className="contact-item"><FaEnvelope className="contact-icon" /> <span>Info@thinkriseusa.com</span></div>
              <div className="contact-item"><FaPhone className="contact-icon" /> <span>1(469)-351-7616</span></div>
              <div className="contact-item"><FaMapMarkerAlt className="contact-icon" /> <span>Frisco, TX 75034</span></div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Follow</h4>
            <div className="social-links">
              <a href="https://shorturl.at/WEP6B" target="_blank" rel="noreferrer" className="social-link" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; ThinkRise USA. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
